<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const user = store('credential', 'getAuth');

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);

            let ind1Str = porog.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            switch (ind1Str) {
                case 'порог рамный':
                    ind1 = 'Нет';
                    break;

                case 'порог низкий':
                    ind1 = 'Есть';
                    break;
            }

            ind2.set(title[2]);

            ind3 = Object.keys(otkrivanie).find((key) =>
                item.title.toLowerCase().includes(key.toLowerCase())
            );
              if (ind3 =='Створка от краев к середине')
              {
                  if (item.title.includes('магнит')){
                      uplot='Магнитный';
                  }
                  else{
                      uplot='Без уплотнения';
                  }

              }
              else{
                  uplot='Без уплотнения';
              }
            count.set(+item.quantity);
            comment.set(item.comment);

            ruchka = Object.keys(ruchki).find((k) =>
                item.title.toLowerCase().includes(k.toLowerCase())
            );

            webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));


            if (options.transp){
                if (item.title.toLowerCase().includes('оставить собранной')){
                    transport ='Оставить собранной';
                }
                else {
                    transport ='Разобрать';
                }

            }

            fetchData = await fetch($ind2);
            change();
        }
    };


    // Настройки для 40 Иван Пятигорск
    if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 40) {
        options = {
            ...options,
            otkrivanie: {
                'Створка влево': 'Створка влево',
                'Створка вправо': 'Створка вправо',
                'Створка от краев к середине': 'Створка к центру',
                'Створка сверху вниз': 'Створка сверху вниз',
            },
            max: {
                width: 2500,
                height: 2300
            },
            recomend: {
                width: 2500,
                height: 2300
            },
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит (RAL 7016)',
                'Св.серый(RAL7040)': 'Св. серый (RAL 7040)',
                'Чёрный(RAL9005)': 'Чёрный (RAL 9005)'
            },
            porojek: {
                'Нет': 'Обычный (рама)',
                'Есть': 'Низкий'
            },
            ruchki: {
                'Нет': 'без ручки',
                'Одна': '1 ручка с лица',
                'Две': '2 ручки',
            },
            webtype: [
                'Стандарт',
                'АнтиПЫЛЬ',
                'АнтиКОШКА',
            ],
            transp: true
        }
    }


    const otkrivanie = options.otkrivanie || {
        'Створка влево': 'Створка влево',
        'Створка сверху вниз': 'Створка сверху вниз',
        'Створка снизу вверх': 'Створка снизу вверх',
        'Створка вправо': 'Створка вправо',
        'Створка от краев к середине': 'Створка от краев к середине'
    };


    const porog = [
        'порог рамный',
        'порог низкий'
    ];

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
    };

    const porojek = options.porojek || {
        'Нет': 'Нет',
        'Есть': 'Есть'
    };

    const ruchki = options.ruchki || {
        'Нет': 'Нет',
        'Одна': 'Одна',
        'Две': 'Две',
    };


    const webtypes = options.webtype || [
        'Обычная',
    ];

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('SlimPro', '', color);
        let options = await network.fetch_ind('SlimPro');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '1600'),
        ind1 = 'Нет',
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        ruchka = 'Одна', // количество ручек
        webtype = parameter('webtype', Object.values(webtypes).shift()),  //parameter('webtype', 'Обычная'), // тип сетки плиссе
        transport ='Оставить собранной',
        uplot='Без уплотнения',
        packing_items = [],
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let ind1Str;

        switch (ind1) {
            case 'Нет':
                ind1Str = 'порог рамный';
                break;

            case 'Есть':
                ind1Str = 'порог низкий';
                break;
        }


        let ruchkaStr;

        switch (ruchka) {
            case 'Нет':
                ruchkaStr = 'без ручки';
                break;
            case 'Одна':
                ruchkaStr = 'одна ручка';
                break;
            case 'Две':
                ruchkaStr = 'две ручки';
                break;
        }

        let transportStr='';
        if (options.transp){
            transportStr =  ' ' + transport;
        }

        //для 40
        let ind1Str2 = ind1Str;
        if (options.transp){
            ind1Str2 = [
                'SlimPro',
                ind3,
                "полотно - " + $webtype,
                ind1,
            ].join(', ')
        }


        let result = {
            type: 'slimpro',
            name: 'SlimPro',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', $webtype, ' ', ind1Str, ' ', ind3, ' ', ruchkaStr, (ind3 =='Створка от краев к середине'? ' '+ uplot : ''), transportStr
            ].join(''),
            title: [
                'SlimPro', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', $webtype, ' ', ind1Str, ' ', ind3, ' ', ruchkaStr, (ind3 =='Створка от краев к середине'? ' ' + uplot : ''), transportStr
            ].join(''),
            params: {
                ind1: ind1Str2,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 25
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамы')) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                    case 'Створка от краев к середине':
                        kolvo = (((w - 30) * 2 + (h - 50) * 2) / 1000).toFixed(3);
                        break;

                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = (((w - 30) * 2 + (h - 50) * 2) / 1000).toFixed(3);
                        break;
                }
            }

            if (name.includes('профиль створки') || (name.includes('магнит') && uplot=='Магнитный' )) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        kolvo = ((h - 52) / 1000).toFixed(3);
                        break;

                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 52) / 1000).toFixed(3);
                        break;
                    case 'Створка от краев к середине':
                        kolvo = ((h - 52) * 2 / 1000).toFixed(3);
                        break;


                }
            }

            if (name.includes('профиль порога') && (ind1 == 'Есть')) {

                kolvo = ((w - 30) / 1000).toFixed(3);

            }


            if (name.includes('сетка мс плиссе')) {

                switch (true) {
                    case ($webtype === 'Обычная' || $webtype === 'Стандарт') && (name.includes('антипыль') || name.includes('антикошка')):
                        return;

                    case $webtype.toLowerCase() === 'антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype.toLowerCase() === 'антикошка' && !name.includes('антикошка'):
                        return;
                }

                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }
                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        wave = Math.ceil(w / 21);
                        kolvo = ((h - 25) / 1000 * wave * 0.034 * k).toFixed(3);
                        break;

                    case 'Створка от краев к середине':
                        wave = Math.ceil(w / 21);
                        kolvo = ((h - 25) / 1000 * wave * 0.034 * k).toFixed(3);
                        break;

                    default:  //Створка вертикал
                        wave = Math.ceil(h / 21);
                        kolvo = ((w - 25) / 1000 * wave * 0.034 * k).toFixed(3);
                        break;
                }
            }

            if (name.includes('вставка под сетку') || name.includes('вставка внутр')) {
                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        kolvo = ((h - 55) / 1000 * 2).toFixed(3);
                        break;
                    case 'Створка от краев к середине':
                        kolvo = ((h - 55) / 1000 * 2 * 2).toFixed(3);
                        break;

                    default:  //'Створка вертикал
                        kolvo = ((w - 55) / 1000 * 2).toFixed(3);
                        break;
                }
            }


            if (name.includes('комплект ')) {


                kolvo = (1).toFixed(3);

            }


            if (name.includes('вставка под профил')) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        kolvo = ((w - 30) / 1000 * 2 + (h - 50) / 1000).toFixed(3);
                        break;
                    case 'Створка от краев к середине':
                        kolvo = (2 * ((w - 30) / 1000 * 2 + (h - 50) / 1000)).toFixed(3);
                        break;

                    default:  //'Створка вертикал
                        kolvo = ((h - 30) / 1000 * 2 + (w - 50) / 1000).toFixed(3);
                        break;
                }
            }




            let c, k;
            switch (ind3) {
                case 'Створка влево':
                case 'Створка вправо':
                case 'Створка от краев к середине':
                    k = h;
                    break;


                    break;

                default:  //'Створка вертикал
                    k = w;
                    break;
            }

            c = ((k / 300) / 2).toFixed(0);

            if (name.includes('нить мс плиссе')) {

                kolvo = (((w + h) + 200) * 2 / 1000 * c).toFixed(3);

                switch (ind3) {

                    case 'Створка от краев к середине':
                        kolvo = kolvo * 2;
                        break;
                }

            }

            if (name.includes('заклеп') || name.includes('люверс')) {
                kolvo = (c * 4).toFixed(0);

                switch (ind3) {

                    case 'Створка от краев к середине':
                        kolvo = kolvo * 2;
                        break;
                }
            }
            if (name.includes('ручка')) {

                switch (ruchka) {

                    case 'Одна':
                        kolvo = (1).toFixed(3);
                        break;
                    case 'Две':
                        kolvo = (2).toFixed(3);
                        break;
                }

                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = kolvo * 2;
                        break;
                }

            }


            if (name.includes('работа')) {
                kolvo = (1).toFixed(3);
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>

        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">

                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">

                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Открытие</label>
                                        <select class="form-control form-select" bind:value={ind3}>
                                            {#each Object.entries(otkrivanie) as [value, name]}
                                                <option value="{value}">{name}</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Цвет</label>
                                        <select class="form-control form-select" bind:value={$ind2}
                                                on:change={() => {changeInd2(); change()}}>
                                            {#each Object.entries(color) as [value, name]}
                                                <option value="{value}">{name}</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                            </div>

                    <div class="form-group boxed">
                        <div class="alert alert-outline-danger">
                            К расчету принимаются только размеры готового изделия!
                        </div>
                    </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">350 ≥ Шир., мм
                                            ≥ { options.recomend && options.recomend.width ? options.recomend.width : 1600 }</label>
                                        <input type="number"
                                               class="form-control text-center { $width > (options.recomend && options.recomend.width ? options.recomend.width : 1600) ? 'text-danger' : '' }"
                                               step="10" min="350"
                                               max="{ options.max && options.max.width ? options.max.width : 1600 }"
                                               bind:value={$width} use:validate_int={$width}>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">350 ≥ Выс., мм
                                            ≥ { options.recomend && options.recomend.height ? options.recomend.height : 2500 }</label>
                                        <input type="number"
                                               class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 2500) ? 'text-danger' : '' }"
                                               step="10" min="350"
                                               max="{ options.max && options.max.height ? options.max.height : 2500 }"
                                               bind:value={$height} use:validate_int={$height}>
                                    </div>
                                </div>
                            </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Порог</label>
                                    <select class="form-control form-select" bind:value={ind1}>
                                        {#each Object.entries(porojek) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Ручка</label>
                                    <select class="form-control form-select" bind:value={ruchka}>
                                        {#each Object.entries(ruchki) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Вид полотна</label>
                                    <select class="form-control form-select" bind:value={$webtype}>
                                        {#each webtypes as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {#if options.transp }
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Транспортировка</label>
                                        <select class="form-control form-select" bind:value={transport}>
                                            <option value="Оставить собранной">Оставить собранной</option>
                                            <option value="Разобрать">Разобрать</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        {/if}

                    {#if ind3 =='Створка от краев к середине' }
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Уплотнитель</label>
                                    <select class="form-control form-select" bind:value={uplot}>
                                        <option value="Без уплотнения">Без уплотнения</option>
                                        <option value="Магнитный">Магнитный</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}

                </div>
            </div>
            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px; height: auto" class="img-fluid  p-3"
                     src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
